import { useDispatch } from 'react-redux';
import { setManuallyClearedQuestionNames } from 'store/Form/actions/form';
import { setPricing } from 'store/Model/actions/model';
import { IQuestion, QuestionType } from 'types/Question.types';

export const useClearFormItemValue = () => {
  const dispatch = useDispatch();

  return (
    setFieldValue: (field: string, value: any) => void,
    question: IQuestion,
    questionName: string
  ) => {
    const value = (() => {
      switch (question.type) {
        case QuestionType.BOOLEAN:
          return false;
        case QuestionType.TEXT:
        case QuestionType.NUMBER:
          return null;
        case QuestionType.RADIO:
        case QuestionType.TABLE:
        case QuestionType.LIST:
        case QuestionType.COLOR:
          return undefined;
        default:
          return undefined;
      }
    })();

    setFieldValue(questionName, value);

    // Clear pricing because clearing question affect pricing
    dispatch(setPricing({}));

    // Add question name to manually reset list which is used to skipDefault in form
    dispatch(setManuallyClearedQuestionNames(questionName));
  };
};
